import { Component, inject } from '@angular/core';
import { Router, RouterLink, RouterOutlet } from '@angular/router';
import { CommonModule } from '@angular/common';
import { ModalPictureComponent } from '@usheru-hff/hff-common/feature-modal-picture';
import { HffCommonUiHeaderModule } from '@usheru-hff/hff-common/ui-header';
import { FooterComponent } from '@usheru-hff/core/footer';
import { VideoFullscreenComponent } from '@usheru-hff/hff-common/ui-video-fullscreen';
import { CookieConsentComponent } from '@usheru-hff/hff-common/feature-cookie-consent';
import { HffCommonUiGoToTopModule } from '@usheru-hff/hff-common/ui-go-to-top';
import { ModalPictureService, SharedUtilsModule } from '@usheru-hff/shared/utils';
import { UiModalDialogComponent } from '@usheru-hff/shared/ui-modal-dialog';
import { NgProgressModule } from 'ngx-progressbar';
import { VideoFullscreenService } from '@usheru-hff/shared/ui-video';
import { ModalService } from '@usheru-hff/shared/utils-modal';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [
    CommonModule,
    RouterLink,
    RouterOutlet,
    HffCommonUiHeaderModule,
    FooterComponent,
    VideoFullscreenComponent,
    ModalPictureComponent,
    CookieConsentComponent,
    HffCommonUiGoToTopModule,
    SharedUtilsModule,
    UiModalDialogComponent,
    NgProgressModule
  ],
  standalone: true
})
export class AppComponent {
  title = 'filmone';

  private readonly modalPictureService = inject(ModalPictureService);
  private readonly videoFullScreenService = inject(VideoFullscreenService);
  private readonly modalService = inject(ModalService);

  modalPictureNeeded$ = this.modalPictureService.image;
  videoFullscreenNeeded$ = this.videoFullScreenService.content$;
  modelDialogNeeded$ = this.modalService.showModal$;
  constructor(private router: Router) {
    const routes = this.router.config;
  }
}
